import { useEffect, useRef } from "react";

const N = 4200;
const PTS = Array.from({ length: N }, (_, i) => {
  const y = 1 - (i / (N - 1)) * 2;
  const r = Math.sqrt(1 - y * y);
  const t = i * Math.PI * (3 - Math.sqrt(5));
  return [Math.cos(t) * r, y, Math.sin(t) * r];
});

export const ParticleOrb = ({ size = 260, busy = false }) => {
  const ref = useRef(null);
  const busyRef = useRef(busy);
  busyRef.current = busy;

  useEffect(() => {
    const cv = ref.current;
    const ctx = cv.getContext("2d");
    const dpr = window.devicePixelRatio || 1;
    cv.width = size * dpr;
    cv.height = size * dpr;
    ctx.scale(dpr, dpr);
    let raf;
    let t = 0;
    const draw = () => {
      t += busyRef.current ? 0.028 : 0.009;
      ctx.clearRect(0, 0, size, size);
      const R = size * 0.36;
      const cx = size / 2;
      const cy = size / 2;
      const ry = t * 0.6;
      const rx = Math.sin(t * 0.4) * 0.5;
      const cyr = Math.cos(ry), syr = Math.sin(ry), cxr = Math.cos(rx), sxr = Math.sin(rx);
      for (let i = 0; i < N; i++) {
        const [x0, y0, z0] = PTS[i];
        const d =
          1 +
          0.16 * Math.sin(3 * x0 + t * 1.3) * Math.cos(2 * y0 - t) +
          0.12 * Math.sin(4 * z0 + t * 1.7) +
          0.07 * Math.cos(6 * y0 + t * 2.1);
        let x = x0 * d, y = y0 * d, z = z0 * d;
        const x1 = x * cyr + z * syr;
        const z1 = -x * syr + z * cyr;
        const y1 = y * cxr - z1 * sxr;
        const z2 = y * sxr + z1 * cxr;
        const p = 2.6 / (2.6 + z2);
        const a = 0.18 + 0.82 * ((1 - z2) / 2.2);
        ctx.fillStyle = `rgba(214,255,252,${a.toFixed(3)})`;
        const s = 1.25 * p;
        ctx.fillRect(cx + x1 * R * p, cy + y1 * R * p, s, s);
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [size]);

  return (
    <div className="relative mx-auto" style={{ width: size, height: size }} data-testid="cai-orb">
      <canvas ref={ref} style={{ width: size, height: size }} />
      <img
        src="/brand/consudoctor-icon.png"
        alt=""
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-90"
        style={{ width: size * 0.12, height: size * 0.12, filter: "brightness(0) invert(1)" }}
      />
    </div>
  );
};
